<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M5.0752 14.5059C5.0752 14.5059 6.5752 14.5059 8.5752 18.0059C8.5752 18.0059 14.134 8.83919 19.0752 7.00586"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>